// Channel topic constants shared between server (publish) and client
// (subscribe). Only inbox/* topics are auth-restricted by the channel server,
// so this global topic reaches every connected client, including anonymous.
export const BROADCAST_TOPIC = 'broadcast';
